"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  defaultLabelLeftArrow: {
    id: 'app.components.Slick.Arrows.LeftArrow',
    defaultMessage: 'Voltar para itens anteriores'
  },
  defaultLabelRightArrow: {
    id: 'app.components.Slick.Arrows.RightArrow',
    defaultMessage: 'Avançar para mais itens'
  }
});